import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import PlayIcon from '../../../assets/images/play-mt-icon.svg';
import {apis} from '../../../services/alm';
import CoursePlayer from '../../common/player/CoursePlayer';
import {useSearchParams} from 'react-router-dom';
import {CourseDetailParmsType} from '../../../interface';

import {defaultImage} from '../../../lib/utils';
import useSubscription from '../../../hooks/useSubscription';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import VideoTutorialWeekDetails from './VideoTutorialWeekDetails';
import useVideoTutorialHook from '../../../hooks/useVideoTutorialHook';
import {VideoTutorialDetailsTab} from './VideoTutorialDetailsTab';
import { Button } from 'alm-react-components';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import withAlmToken from '../../common/withAlmToken';
import PageLoader from '../../common/loader/PageLoader';
import { AppContext } from '../../../context/AppProvider';
import useAlmCorporateStatus from '../../../hooks/useAlmCorporateStatus';
const VideoTutorialDetails = () => {
  const {courseId} = useParams<CourseDetailParmsType>();
  const [courseData, setCourseData] = useState<any>(null);
  const [playCourse, setPlayCourse] = useState(false);
  const [isUserEnrolled, setUserEnrolled] = useState(false);
  const navigate = useNavigate();
  const [query] = useSearchParams();
  const courseType: any = query.get('courseType');
  const {isVideoTutorialData} = useVideoTutorialHook();
  const [loading, setLoading] = useState(false);
  const [courseList, setCourseList] = useState<any>(null);
  const {callSubscription} = useSubscription();
  const location = useLocation();
  const from: any = location?.state?.from;
  const { state } = useContext(AppContext);
  useAlmCorporateStatus();
  
  useEffect(() => {
    if(state.user){
      if(!state.user?.corporateAccountId)
        callSubscription("valid");
    }
  }, [state.user]);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response: any = await apis.getProgramList(courseId);
      if (response?.data?.relationships?.enrollment) {
        setUserEnrolled(true);
      }
      setCourseData(response);
    } catch (error) {
      console.error("Error fetching course data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [courseId, isUserEnrolled]);
  useEffect(() => {
    if (isVideoTutorialData) {
      const list = isVideoTutorialData?.map((course: any) => {
        return {
          id: course.id,
          bannerUrl: course?.attributes?.bannerUrl,
          name: getLocalizedContent(course?.attributes?.localizedMetadata)?.name,
          imageUrl: course?.attributes?.imageUrl,

        };
      });
      setCourseList(list);
    }
  }, [isVideoTutorialData]);

  const instanceID = courseData?.data?.relationships?.instances?.data[0].id;

  const handleVideo = async () => {
    try {
      const res = await apis.userEnroll(courseId, instanceID);
      if (res?.data?.type === 'learningObjectInstanceEnrollment') {
        setUserEnrolled(true);
      }
      setPlayCourse(true);
    } catch (error) {
      console.log('error', error);
    }
  };
  const courseUpdate = async (id: any) => {
    setPlayCourse(false);
    navigate(`/video-tutorial-details/${id}`,{state:{from:from}});
  };
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  const content = getLocalizedContent(courseData?.data?.attributes?.localizedMetadata);
  return (
    <>
      <section className="h-fit">
        {loading || !courseData ? (
          <PageLoader />
        ) : (
          <>
            <div className="px-6 pt-6 lg:px-8 xl:pr-32 xl:pl-32 md:pt-14 w-[100%] md:px-8">
              <div className="flex justify-between items-center relative">
                <Button
                  onClick={() => {
                    navigate(from)
                  }}
                  variant="default"
                  className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0"
                >
                  <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
                </Button>
              </div>
            </div>
            <div className="gap-6 xl:gap-6 md:grid md:grid-cols-3 py-5 mx-auto md:py-8 px-4 xl:px-32 md:px-8 lg:px-8">
              {courseId && (
                <div className="col-span-2 pb-4">
                  <div className={`mb-6 max-h-[568px] aspect-[6/3] md:aspect-[6/3] xl:aspect-[6/3] 2xl:aspect-[6/3] relative`}>
                    {courseId && playCourse ? (
                      <CoursePlayer
                        cid={courseId}
                        goBackUrl={location.pathname}
                        fullScreen={false}
                        playVideo={setPlayCourse}
                      />
                    ) : (
                      <>
                        {courseData?.data?.attributes?.bannerUrl ? (
                          <img
                            src={courseData?.data?.attributes?.bannerUrl}
                            alt=""
                            className="object-cover w-full max-h-[568px] rounded-2xl"
                          />
                        ) : (
                          <img
                            src={defaultImage()}
                            alt=""
                            className="object-cover w-full max-h-[568px] rounded-2xl"
                          />
                        )}
                        <div
                          className="flex absolute justify-center items-center cursor-pointer course-play-div w-[90px] h-[60px] dark:bg-fillMidGrayCard opacity-[0.8] rounded-2xl "
                          onClick={() => handleVideo()}
                        >
                        <img src={PlayIcon} alt="No Image" className="course-play-icon " />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="gap-4 xl:gap-8 md:grid md:grid-cols-3 max-w-screen-xl">
                    <div className="col-span-2 pb-4 flex flex-col">
                      <h2 className="lg:text-xl xl:text-2xl 2xl:text-3xl font-opensansSemiBold font-opensansSemiBold text-left">
                        {content?.name}
                      </h2>
                      <p className="mt-3 text-base font-opensansLight tracking-wider">
                        {content?.description}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div className="mt-4 md:mt-0">
                <div className="gap-5 grid dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-8 dark:focus:ring-[#3b5998]/55 me-2 mb-2 w-full">
                  <div className="col-span-2 pe-4 flex flex-col text-left">
                  <h2 className="lg:text-xl xl:text-2xl font-barlowRegular">{content?.name}</h2>
                  </div>
                </div>
                <VideoTutorialWeekDetails
                  courseUpdate={courseUpdate}
                  courseList={courseList}
                  courseId={courseId}
                  courseType={courseType}
                />
              </div>
            </div>
          </>
        )}
      </section>
      {courseId && (
        <VideoTutorialDetailsTab courseResponse={courseData?.data} courseId={courseId} />
      )}
    </>
  );
};

export default withAlmToken(VideoTutorialDetails);
